export enum ProductUnit {
  Forfait = 'forfait',
  Hour = 'h',
  Kilogram = 'kg',
  Meter = 'm',
  Unit = 'u',
}
